<template>
  <div>
    <SummaryStat></SummaryStat>
  </div>
</template>

<script>
import SummaryStat from '../components/SummaryStat.vue';

export default {
  components: {
    SummaryStat,
  },
};
</script>
